import { motion } from 'framer-motion';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/Footer';
import { GuidedForm } from '@/components/contact/GuidedForm';
import { Shield, Clock, Sparkles } from 'lucide-react';
import { Seo } from '@/components/Seo';
import { breadcrumbLd, contactPageLd } from '@/lib/seo';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Seo
        title="Contact Yaw CTV | Free Government & CTV Advertising Consultation"
        description="Tell us about your campaign and get a tailored strategy. SDVOSB/MBO certified media buying, OTT/CTV, programmatic, and social — response within 24 hours."
        path="/contact"
        jsonLd={[
          breadcrumbLd([
            { name: 'Home', path: '/' },
            { name: 'Contact', path: '/contact' },
          ]),
          contactPageLd(),
        ]}
      />
      <Header />

      <main className="flex-1">
        {/* Hero Section — dark band keeps the transparent header logo readable */}
        <section className="pt-28 sm:pt-32 pb-12 sm:pb-16 bg-navy-deep">
          <div className="container mx-auto px-5 sm:px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="max-w-2xl mx-auto text-center"
            >
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-4">
                Let's Build Your Campaign
              </h1>
              <p className="text-lg text-white/70 mb-6">
                Answer a few questions so we can prepare a tailored strategy for your organization.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-white/70">
                <div className="flex items-center gap-2">
                  <Sparkles className="w-4 h-4 text-gold" />
                  <span>Free Consultation</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock className="w-4 h-4 text-gold" />
                  <span>Response within 24 hours</span>
                </div>
                <div className="flex items-center gap-2">
                  <Shield className="w-4 h-4 text-gold" />
                  <span>No obligation</span>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Form Section */}
        <section className="py-8 sm:py-12">
          <div className="container mx-auto px-5 sm:px-6">
            <GuidedForm />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
